import script from "./PWAPromptComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PWAPromptComponent.vue?vue&type=script&setup=true&lang=js"

import "./PWAPromptComponent.vue?vue&type=style&index=0&id=40088a42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40088a42"]])

export default __exports__